import React from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink, DEFAULT_WA_MESSAGE } from "../lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={buildWhatsAppLink(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل عبر واتساب"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 start-5 z-50 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full px-5 py-3.5 font-semibold shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">واتساب</span>
    </a>
  );
}
